/* Regex is not meant to validate an email,
just to help guide the user to put the correct format */
// Regex from https://www.w3schools.com/tags/att_input_pattern.asp
/*
  [a-z0-9._%+-]+  at least one character
  @               followed by a @ sign
  [a-z0-9._%-]+   at least one character
  .               followed by a .
  [a-z]{2,}        at least two letters
*/
const emailFormatRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

export const isEmailFormatValid = (email: string): boolean => {
  if (!email) {
    return false;
  }

  return emailFormatRegex.test(email);
};
